export function generateSecureRandomString(length = 16) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(36))
    .join('')
    .slice(0, length);
}
